import { render, staticRenderFns } from "./customer-assignation-item.vue?vue&type=template&id=39106a68&scoped=true&"
import script from "./customer-assignation-item.vue?vue&type=script&lang=js&"
export * from "./customer-assignation-item.vue?vue&type=script&lang=js&"
import style0 from "./customer-assignation-item.vue?vue&type=style&index=0&id=39106a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39106a68",
  null
  
)

export default component.exports